import { Box, Tag } from '@iheartjane/reefer';

export interface ActiveFilterTagProps {
  label: string;
  valuesCount: number;
}
export const ActiveFilterTag = ({
  valuesCount,
  label,
}: ActiveFilterTagProps) => {
  if (valuesCount === 0) {
    return null;
  }

  return (
    <Box
      mr={4}
      role="status"
      ariaLabel={`${valuesCount} active ${label} filter${
        valuesCount > 1 ? 's' : ''
      }`}
    >
      <Tag
        label={valuesCount.toString()}
        background="purple-light"
        color="purple-dark"
      />
    </Box>
  );
};
